export const profileContactListStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		height: '100%',
		overflow: 'hidden',
	},

	loader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
	},

	emptyContent: {
		top: 'calc(50% - 100px)',

		'& .MuiTypography-root': {
			maxWidth: '270px',
			width: '100%',
		},
	},

	modal: {
		'.MuiPaper-root': {
			position: 'relative',
			minWidth: '1170px',
			width: '100%',
			maxHeight: 'calc(100% - 48px)',
			height: '100%',
			paddingTop: '48px',
			margin: '0 15px',
			borderRadius: '8px',
		},

		'&.MuiDialog-root': {},
	},

	deleteContactModal: {
		'.MuiPaper-root': {
			width: '100%',
			maxWidth: '770px',
			padding: '48px 200px',
		},
	},
};
